import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,MenuItem, Select
} from "@mui/material";
import {
  useDeleteCustomerMutation,
  useGetAllInvoiceQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetWorkOrderQuery,
  useGetDriverQuery
} from "../../../Api/attoDeskApi";
import {
  ICompanyDetails,
  IInvoice,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import { WorkOrderStatus } from "../../../Core/Enum/enum";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
   case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedCoursing, setSelectedCoursing] = useState<IInvoice | null>(
    null
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IInvoice | null>(
    null
  );
  const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  const [drivers, setDrivers] = useState<any[]>([]);
  const { data: driverData } = useGetDriverQuery({ searchText: "", id: "" });
  const [selectedDriver, setSelectedDriver] = useState<string>("");
  const [selectedCompany, setSelectedCompany] = useState<string>("");
  const [dateFilter, setDateFilter] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const componentRef = useRef<HTMLDivElement>(null);


  const { data, isLoading, isError, refetch } = useGetAllInvoiceQuery({
    searchText: currentSearchQuery,
    id: "",
    quoteWorkOrderCustomerId: "",
    quoteWorkOrderCustomerProjectId: "",
  });
  

  const { data: companyData, isLoading: companyLoading } = useGetCompanyQuery({
    searchText: "",
    id: "",
  });

   useEffect(() => {
      if (driverData && Array.isArray(driverData.data)) {
        const filteredDrivers = driverData.data.filter((driver: any) => driver.driverUserRole === 'driver');
        setDrivers(driverData.data);
      }
    }, [driverData]);

    


     useEffect(() => {
  if (dateFilter !== "custom") {
    let start = "";
    let end = "";
    const now = dayjs().tz("America/Toronto");
    //const now = dayjs().tz("Etc/GMT+12");

    switch (dateFilter) {
      case "today":
        start = end = now.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = end = now.subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = now.startOf("week").format("YYYY-MM-DD");
        end = now.endOf("week").format("YYYY-MM-DD"); //  Include full week
        break;
      case "last_week":
        start = now.subtract(1, "week").startOf("week").format("YYYY-MM-DD");
        end = now.subtract(1, "week").endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = now.startOf("month").format("YYYY-MM-DD");
        end = now.endOf("month").format("YYYY-MM-DD"); //  Ensure full month is covered
        break;
      case "last_month":
        start = now.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        end = now.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
        break;
      default:
        break;
    }

    setStartDate(start);
    setEndDate(end);
  }
}, [dateFilter]);
 
    
  
    // Handle driver selection change
    const handleDriverChange = (event: any) => {
      const selectedDriver = event.target.value;
      setSelectedDriver(selectedDriver); // Update state with the selected driver
    
    };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IInvoice) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
   
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IInvoice) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteCustomerMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the customer");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IInvoice[] = Array.isArray(data?.data)
    ? (data?.data as IInvoice[])
    : [];

    const filteredCoursings = coursings.filter((row) => {
      const matchesDriver =
        !selectedDriver || (Array.isArray(row?.drivers) && row.drivers.some((driver) => driver.id === selectedDriver));
    
      const matchesDate =
        !dateFilter || (() => {
          if (!row.created_at) return false; // ✅ Ensure row.created_at exists
    
            const saleDate = new Date(row.created_at).toLocaleDateString("en-CA");
            const startDateString = new Date(startDate).toLocaleDateString("en-CA");
            const endDateString = new Date(endDate).toLocaleDateString("en-CA");
    
            const isValid = saleDate >= startDateString && saleDate <= endDateString;
            return isValid;
          })();
    
      const matchesIssue =
        !selectedCompany || (Array.isArray(row.company) 
        ? row.company.some((issue) => issue.id === selectedCompany) // If it's an array, check within
        : row.company?.id === Number(selectedCompany));
    
      return matchesDriver && matchesDate && matchesIssue;
    });
    

//console.log("Filtered Coursings:", filteredCoursings);


const exportToExcel = () => {
  // Define the filename
  const fileName = "Report.xlsx";

  // Convert the filtered data into a worksheet
  const worksheet = XLSX.utils.json_to_sheet(filteredCoursings);

  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Coursings");

  // Write and trigger download
  XLSX.writeFile(workbook, fileName);
};


    

  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };

  const handleAddProductClick = () => {
    navigate("/quote/create");
  };

  


  return (
   <><div>
   <Grid container spacing={1} sx={{ marginTop: 1 }}>
     <Grid item xs={12}>
       <Card className={classes.card}>
         <Box mb={2} padding={2}>
           <Grid container spacing={2}>
             {/* Select Driver */}
             <Grid item lg={2} md={2} sm={6} xs={12}>
               <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Team Member
               </Typography>
               <Select
                 className={classes.textField}
                 value={selectedDriver}
                 onChange={handleDriverChange}
                 displayEmpty
                 
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">All Team Members</MenuItem>
                 {drivers.map((driver: any) => (
                   <MenuItem key={driver.id} value={driver.id}>
                     {`${capitalize(driver.driverFirstName)} ${capitalize(driver.driverLastName)}`}
                   </MenuItem>
                 ))}
               </Select>
             </Grid>


             <Grid item lg={2} md={2} sm={6} xs={12}>
  <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
    Issue From
  </Typography>
  <Select
    className={classes.textField}
    value={selectedCompany || ""}
    onChange={(event) => setSelectedCompany(event.target.value)}
    displayEmpty
    sx={{
      height: "37px",
      fontSize: "14px",
      padding: "4px",
      minWidth: "120px"
    }}
  >
    <MenuItem value="">All Companies</MenuItem>
    {companyData && Array.isArray(companyData.data) ? (
      companyData.data.map((company: any) => (
        <MenuItem key={company.id} value={company.id}>
          {`${capitalize(company.companyName)}`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No data available</MenuItem>
    )}
  </Select>
</Grid>




 
             {/* Select Date */}
             <Grid item lg={2} md={2} sm={6} xs={12}>
               <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Date
               </Typography>
               <Select
                 className={classes.textField}
                 value={dateFilter}
                 onChange={(e) => setDateFilter(e.target.value)}
                 displayEmpty
                
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">Select date filter</MenuItem>
                 <MenuItem value="today">Today</MenuItem>
                 <MenuItem value="yesterday">Yesterday</MenuItem>
                 <MenuItem value="this_week">This Week</MenuItem>
                 <MenuItem value="last_week">Last Week</MenuItem>
                 <MenuItem value="this_month">This Month</MenuItem>
                 <MenuItem value="last_month">Last Month</MenuItem>
                 <MenuItem value="custom">Custom</MenuItem>
               </Select>
             </Grid>
 
             {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
             {dateFilter === "custom" && (
               <>
                 <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     Start Date
                   </Typography>
                   <TextField
                   variant="outlined"
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={startDate}
                     onChange={(e) => setStartDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
                     
                   />
                 </Grid>
                 <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     End Date
                   </Typography>
                   <TextField
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={endDate}
                     onChange={(e) => setEndDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
              
                   />
                 </Grid>
               </>
             )}
           </Grid>
         </Box>
       </Card>
     </Grid>
   </Grid>
 </div>
 
 <div ref={componentRef} >
    <Grid container spacing={1}  sx={{ marginTop: 1 }}>
    <Grid item xs={12} sm={12} md={12}>
    <Card className={classes.card}>
        <Grid
          container
          justifyContent={"space-between"}
          spacing={5}
          sx={{ borderBottom: 2, padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
            <Typography className={classes.cardTitle}></Typography>
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xs={8}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
 

              <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CiSearch className={classes.searchWidgetIcon} />
                      </InputAdornment>
                    ),
                    classes: {
                      root: classes.formControlList,
                    },
                  }}
                  fullWidth
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Invoice Number .."
                  sx={{ width: "100%" }}
                  size="small" />
              </Grid>



              {filteredCoursings.length > 0 && (
  <Grid item sx={{ '@media print': {
    display: 'none',
  } }}>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => componentRef.current}
    />
  </Grid>
)}
            </Grid>
          </Grid>
        </Grid>

        <Grid>
          <TableContainer>
            <Table className={classes.table} sx={{
              width: "100%",
              marginBottom: "1.5rem",
              verticalAlign: "top",
              "& > :not(caption) > * > *": {
                padding: "8px", // Ensure custom padding is applied
              },
              '@media print': {
                width: '100%',
                tableLayout: 'fixed', // Ensures equal column distribution
                whiteSpace: 'normal', // Allows text wrapping
              },
            }}>
              <TableHead className={classes.tableHeaderRow}>
                <TableRow>
                  {/* <TableCell className={classes.tablheader}>
                    <CustomCheckbox name="checkbox" />
                  </TableCell> */}
                  <TableCell className={classes.tablheader}>
                    <strong>#</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Invoice Number</strong>
                  </TableCell>
                    <TableCell className={classes.tablheader}>
                   <strong>Mode</strong>
                   </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Status</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Amount</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Paid Amt</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Balance</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Team Member(s)</strong>
                  </TableCell>
                  {/* <TableCell className={classes.tablheader}>
                    <strong>Trip details</strong>
                  </TableCell> */}
                  {/* <TableCell className={classes.tablheader}>
      <strong>D.Price</strong>
    </TableCell> */}
                  <TableCell className={classes.tablheader}>
                    <strong>Issue From</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Issue For</strong>
                  </TableCell>

                  {/* <TableCell className={classes.tablheader}>
      <strong>Status</strong>
    </TableCell> */}
                  <TableCell
                    className={classes.tablheader}
                    sx={{ textAlign: "right" ,'@media print': {
                      display: 'none',
                    } }}
                   
                  >
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isError || filteredCoursings.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={20} align="center">
                      {isError ? "Error fetching data" : "No data available"}
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredCoursings
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: IInvoice, index) => {
                      const statusLabel = getStatusLabel(
                        row.quoteWorkOrderStatus
                      );
                      const statusColor = getStatusColor(
                        row.quoteWorkOrderStatus
                      );
                      const balance = Math.max(0, parseFloat(row.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(row.amount_paid || "0")));



                      return (
                        <TableRow key={row.id} className={classes.tableRowHover}>
                          {/* <TableCell className={classes.tablCell}>
                            <CustomCheckbox name="checkbox" />
                          </TableCell> */}

                          <TableCell scope="row" className={classes.tablCell}>
                            {page * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {row.InvoiceNo}
                          </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                         {row.Mode}
                        </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            <Button
                              className={classes.statusButtonList}
                              style={{
                                color: statusColor,
                                backgroundColor: row.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                  ? "#e1f8d5"
                                  : row.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                    ? "#f8d7da"
                                    : row.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                      ? "lightyellow"
                                      : row.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                        ? "#e2fafa"
                                        : "#ffffff", // Fallback for other statuses
                                border: "solid 1px",
                                borderColor: statusColor,
                                borderRadius: "8px",
                              }}
                            >
                              {statusLabel}
                            </Button>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {"$"}
                            {parseFloat(
                              row.quoteWorkOrderSaleGrandTotal || "0"
                            ).toFixed(2)}

                          </TableCell>
                          <TableCell component="th" scope="row" className={classes.tablCell}>
                            {"$"}{(row.amount_paid || "0")}
                          </TableCell>

                          <TableCell component="th" scope="row" className={classes.tablCell}>
                            {"$"}{balance.toFixed(2)}
                          </TableCell>

                          <TableCell component="th" scope="row" className={classes.tablCell}>
  {Array.isArray(row?.drivers) && row.drivers.length
    ? row.drivers
        .map((driver: { id: number; driverFirstName: string; driverLastName: string }) => {
          // Parse assign_to if it's a valid JSON string
          const assignedDrivers = row?.assign_driver?.assign_to ? JSON.parse(row.assign_driver.assign_to) : [];

          // Find the matching driver assignment by driverId
          const assignedDriver = assignedDrivers.find((assign: { driverId: number }) => assign.driverId === driver.id);

          // Get the price if assigned, otherwise default to "Not Assigned"
          const priceText = assignedDriver ? `- $${assignedDriver.price}` : '';

          // Return formatted string with driver name and price
          return `${capitalize(driver.driverFirstName)} ${capitalize(driver.driverLastName)} ${priceText}`;
        })
        .join(', ')
    : 'Not Assigned'}
</TableCell>


                          {/* <TableCell component="th" scope="row" className={classes.tablCell}>
  {(row?.quoteWorkOrderSale) && row.quoteWorkOrderSale.length
    ? row.quoteWorkOrderSale
        .map((sale: any) => 
          sale?.transferTypeFrom && sale?.transferTypeTo
            ? `${sale.transferTypeFrom} to ${sale.transferTypeTo}`
            : 'No Transfer Info'
        )
        .join(', ')
    : 'No Transfer Info'}
</TableCell> */}



                          <TableCell scope="row" className={classes.tablCell}>
                            {row.company.companyName || row.project.projectName || ""}

                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid container>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                {row.project?.projectName || row.customer?.customerCompanyName || ""}
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                              {row.customer ? (
        `${row.customer.customerFirstName?.charAt(0).toUpperCase() + row.customer.customerFirstName?.slice(1).toLowerCase() || ""} 
        ${row.customer.customerLastName?.charAt(0).toUpperCase() + row.customer.customerLastName?.slice(1).toLowerCase() || ""}`
      ) : ("Walk-in ")}
                              </Grid>
                            </Grid>
                          </TableCell>

                          {/* <TableCell scope="row" className={classes.tablCell}>
                      <Button
                        className={classes.statusButtonList}
                        style={{
                          color: statusColor,
                          border: "solid 1px",
                          borderColor: statusColor,
                          borderRadius: "8px",
                        }}
                      >
                        {statusLabel}
                      </Button>
                    </TableCell> */}
                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid
                              container
                              spacing={1}
                              sx={{ display: "flex", justifyContent: "flex-end" }}
                            >


                              <Grid item  sx={{ '@media print': {
                      display: 'none',
                    } }}>
                                <Button
                                  variant="contained"
                                  className={classes.viewButtonList}
                                  onClick={() => navigate(`/invoice/history/${row.id}`)}
                                >
                                  <VisibilitySharpIcon
                                    className={classes.viewListIcon} />
                                </Button>
                              </Grid>



                              {/* <Grid item>
                    <Button
variant="contained"
className={classes.editButtonList}
onClick={() =>
navigate(
row.project?.id
  ? `/invoice/project/edit/${row.id}` // Redirect to project-specific edit page
  : `/invoice/edit/${row.id}` // Redirect to regular edit page
)
}
>
<EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid> */}


                            </Grid>
                          </TableCell>
                        </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
            <Grid sx={{ '@media print': {
                    display: 'none',
                  } }}
              spacing={5}
              p={"18px"}
              py={4}
              justifyContent={"end"}
              container
              textAlign={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid
                sx={{
                  textAlign: "end",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Pagination 
                  count={coursings.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage} />
              </Grid>
            </Grid>
          </TableContainer>

          {coursingToDelete && (
            <DeletePopup
              open={openDeleteCategory}
              handleCloseDelete={handleCloseDeletePopup}
              onConfirm={async () => {
                await handleDelete(coursingToDelete.id.toString());
              } }
              title="Delete Quote"
              content={`Are you sure you want to delete "${coursingToDelete.quoteWorkOrderNo}"?`} />
          )}
        </Grid>
      </Card>
      </Grid>
      </Grid>
      </div>
      </>
  );
};

export default Index;
